import { render, staticRenderFns } from "./WeightsViewerDialog.vue?vue&type=template&id=4c1e5d85"
import script from "./WeightsViewerDialog.vue?vue&type=script&lang=ts"
export * from "./WeightsViewerDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports